import PropTypes from 'prop-types';
import React from 'react';
import UserCard from 'components/users/UserCard';
import { stringifyList } from '../../../../../utils';
import { ResourceCardElement } from 'components/ResourceCardElements';

const EstimatorCard = ({ estimator, workrooms }) => (<UserCard user={estimator} type="estimators">
  <ResourceCardElement
    title="Workroom(s)"
    size="medium"
    value={stringifyList(workrooms) || 'No Workroom'}
  />
</UserCard>);

EstimatorCard.propTypes = { estimator: PropTypes.object, workrooms: PropTypes.array };

export default EstimatorCard;



// WEBPACK FOOTER //
// ./client/app/screens/main/screens/estimators/components/estimatorCard.jsx